import { message } from "antd";
import { gatewayInstance } from "../server/gateway";

// 获取工作台列表
export async function getWorkbenchList(body: any = {}) {
  return gatewayInstance
    .request({
      api: "appstore.workbench.client.getWorkbench",
      method: "POST",
      body: { ...body }
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}
// 获取当前工作台详细信息
export async function getWorkbenchDetailInfo(body: any = {}) {
  return gatewayInstance
    .request({
      api: "appstore.workbench.client.getWorkbenchDetail",
      method: "POST",
      body: { ...body }
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

// 保存个人工作台设置
// export async function saveWorkbench(body: any = {}) {
//   return gatewayInstance
//     .request({
//       api: "appstore.workbench.client.saveWorkbench",
//       method: "POST",
//       body
//     })
//     .then((res) => res)
//     .catch((err) => {
//       message.error(err.message);
//     });
// }

// 获取批量code
export async function getBatchFouceOpenCodeList(body: any = {}) {
  return gatewayInstance
    .request({
      api: "appstore.workbench.client.getBatchFouceOpenCode",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

// 获取模板库的版本
export async function getLatestVersion(body: any = {}) {
  return gatewayInstance
    .request({
      api: "appstore.workbench.client.getLatestVersion",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

// 系统内部应用获取数据
export async function getSystemData(api: string, body: any = {}) {
  console.log(333, body);
  return gatewayInstance
    .request({
      api: api,
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}
